import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import Home from "@/pages/Home";
import ArchiveEntry from "@/pages/ArchiveEntry";
import Write from "@/pages/Write";
import { ContentProvider } from "@/content";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="grain">
      <ContentProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/archive/:slug" element={<ArchiveEntry />} />
            <Route path="/write" element={<Write />} />
          </Routes>
        </BrowserRouter>
      </ContentProvider>
    </div>
  );
}

export default App;
